export const dateParser = (date: Date | string) => (typeof date === 'string' ? new Date(date) : date);
